module.exports = __webpack_public_path__ + "img/natural-paper-texture.f5055e3b.jpg";